import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AuthModule, OidcConfigService, PublicEventsService, EventTypes, LogLevel } from 'angular-auth-oidc-client';

import { filter, map, switchMap } from 'rxjs/operators';

import { AppRoutingModule } from './app-routing.module';
import { SharedServicesModule } from './shared-services/shared-services.module';
import { MainModule } from './main/main.module';
import { SharedComponentsModule } from './shared-components/shared-components.module';

import { AppComponent } from './app.component';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from './NgbDateFRParserFormatter';
import { AppConfig } from './app.config';

const oidcConfigurationJsonUrl = 'config/auth.clientConfiguration.json';

export function configureAuth(oidcConfigService: OidcConfigService, httpClient: HttpClient) {
    const setupAction$ = httpClient.get<any>(oidcConfigurationJsonUrl).pipe(
        map((customConfig) => {
            return {
                stsServer: customConfig.stsServer,
                redirectUrl: customConfig.redirect_url,
                clientId: customConfig.client_id,
                responseType: customConfig.response_type,
                scope: customConfig.scope,
                postLogoutRedirectUri: customConfig.post_logout_redirect_uri,
                startCheckSession: customConfig.start_checksession,
                silentRenew: customConfig.silent_renew,
                silentRenewUrl: customConfig.silent_renew_url,
                postLoginRoute: customConfig.post_login_route,
                forbiddenRoute: customConfig.forbidden_route,
                unauthorizedRoute: customConfig.unauthorized_route,
                logLevel: customConfig.log_console_debug_active ? LogLevel.Debug : LogLevel.Error,
                maxIdTokenIatOffsetAllowedInSeconds: customConfig.max_id_token_iat_offset_allowed_in_seconds,
                historyCleanupOff: true,
                // autoUserinfo: false,
            };
        }),
        switchMap((config) =>  oidcConfigService.withConfig(config))
    );

    return () => setupAction$.toPromise();
}

function initConfig(config: AppConfig){
    return () => config.load()
}

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        SharedServicesModule,
        MainModule,
        SharedComponentsModule,
        AuthModule.forRoot(),
        AppRoutingModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter },
        OidcConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: configureAuth,
            deps: [OidcConfigService, HttpClient],
            multi: true,
        },
        AppConfig,
        { 
            provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true 
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private readonly eventService: PublicEventsService) {
        this.eventService
            .registerForEvents()
            .pipe(filter((notification) => notification.type === EventTypes.ConfigLoaded))
            .subscribe((config) => console.log('ConfigLoaded', config));
    }
}
